import { FilterToolbarItem, FilterToolbarItemId } from 'src/components/Filters';
import { PosEnumSelect } from 'src/core/POS/PosSelect';
import { ContentId } from 'src/utils/constants/contentId';
import { PAYMENT_METHOD_TYPE_TO_CID } from 'src/utils/constants/contentIdMaps';
import { PurchasePaymentMethodType } from 'src/WebApiController';

type PurchasePaymentMethodFilter = {
  paymentMethod: PurchasePaymentMethodType | null;
};

export const usePurchasePaymentMethodFilters = <
  TFilter extends PurchasePaymentMethodFilter,
>({
  query,
  setQuery,
}: {
  query: TFilter;
  setQuery: (query: TFilter) => void;
}): FilterToolbarItem => {
  return {
    filterId: 'paymentMethod' as FilterToolbarItemId,
    labelContentId: ContentId.PaymentType,
    filterQueryKeys: ['paymentMethod'] as FilterToolbarItemId[],
    filterItem: (
      <PosEnumSelect
        style={{ width: '100%' }}
        value={query.paymentMethod}
        placeholderText={ContentId.AllPaymentTypes}
        enableEmptySelection
        onChange={(paymentMethod) => {
          if (paymentMethod !== query.paymentMethod) {
            setQuery({
              ...query,
              paymentMethod: paymentMethod,
            });
          }
        }}
        valueOptionsContent={PAYMENT_METHOD_TYPE_TO_CID}
      />
    ),
  };
};
